import loadable from '@loadable/component';
export const manifest = {
  SmeTicker: {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeTicker";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeTicker" */
          './sme-ticker'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./sme-ticker");
            }

            return eval('require.resolve')("./sme-ticker");
          }

        }, {
          resolveComponent: m => m.SmeTicker
        })
      }
    }
  },
  'SmeTicker.OverflowBackground': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeTickerOverflowBackground";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeTickerOverflowBackground" */
          './overflow-background'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./overflow-background");
            }

            return eval('require.resolve')("./overflow-background");
          }

        }, {
          resolveComponent: m => m.OverflowBackground
        })
      }
    }
  }
};